export const TIMEOUT_ERROR = 'TIMEOUT_ERROR';
export const TIMEOUT_RESET = 'TIMEOUT_RESET';